import { FilterValues } from '@/app/[locale]/collection/types/filter-store-v2.types'
import {
  __cCollection2Service,
  __cCollectionService,
} from '@/services/client/__c.collection.service'
import { TCollectionData } from '@/types/collection'
import { ProductQueryParams, ProductResponseFormatted } from '@/types/product'
import { useInfiniteQuery, useQuery } from '@tanstack/react-query'

export function useCollectionProducts(
  params: ProductQueryParams,
  initData?: ProductResponseFormatted,
  filters?: { [key: string]: string[] | string | number | undefined }
) {
  return useInfiniteQuery({
    queryKey: ['collection-products', params, filters],
    queryFn: async ({ pageParam = 1 }) => {
      return await __cCollectionService.getProductsBySlug({
        ...params,
        ...filters,
        page: pageParam,
      })
    },
    initialPageParam: 1,
    initialData: initData
      ? {
          pages: [initData],
          pageParams: [1],
        }
      : undefined,
    getNextPageParam: (lastPage) => {
      if (lastPage.current_page < lastPage.last_page) {
        return lastPage.current_page + 1
      }
      return undefined
    },
  })
}

// list id product và collection id của chương trình x2coolcash
export const useX2CoolCashProducts = () => {
  return useQuery({
    queryKey: ['x2-coolcash-products'],
    queryFn: () => __cCollectionService.getX2CoolCashProducts(),
    staleTime: 1000 * 60 * 5, // Cache data for 5 minutes
    refetchOnWindowFocus: false, // Prevent refetching on window focus
  })
}

// collection no filter
export function useCollectionProductsNoFilter(
  params: ProductQueryParams,
  filters: FilterValues = {},
  initData?: TCollectionData
) {
  return useInfiniteQuery<TCollectionData>({
    queryKey: ['collection-products-no-filter', params, filters],
    queryFn: async ({ pageParam = 1 }) => {
      const { slug, ...restParams } = params
      const filtersWithPage: FilterValues = {
        ...(restParams as FilterValues),
        ...filters,
        page: pageParam as number,
      }
      return await __cCollection2Service.getCollectionData(
        slug || '',
        filtersWithPage
      )
    },
    initialPageParam: 1,
    initialData: initData
      ? {
          pages: [initData],
          pageParams: [1],
        }
      : undefined,
    getNextPageParam: (lastPage) => {
      if (lastPage.pagination.has_next_page) {
        return lastPage.pagination.current_page + 1
      }
      return undefined
    },
  })
}
